<template>
  <div class="Login" id="login">
    <div class="main">
      <div class="header">
        <img src="../assets/login-logo.png" alt="" />
      </div>
      <div class="panel">
        <div class="input">
          <input
            type="number"
            maxlength="11"
            placeholder="请输入手机号"
            v-model="tel"
            oninput="value=value.replace(/[^\d]/g,'')"
          />
        </div>
        <div class="code">
          <input
            type="number"
            maxlength="4"
            placeholder="请输入验证码"
            oninput="value=value.replace(/[^\d]/g,'')"
            v-model="code"
          />
          <span
            :class="{ wait: seconds > 0 }"
            @click="GetCode"
            v-text="seconds != 0 ? '获取验证码(' + seconds + ')' : '获取验证码'"
          ></span>
        </div>
      </div>
      <div class="btnLogin"  @click="Login">登陆</div>

      <div class="footer">
        <!-- <div class="tips">
          欢迎登录旅游团队行程备案系统
        </div> -->
         <div class="tips">
          欢迎登录苏州旅游团队电子行程单服务平台
        </div>
        <div class="corp">
          技术支持：苏州苏恒网络科技有限公司
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var timer;
export default {
  name: "Login",
  data() {
    return {
      tel: "",
      code: "",
      seconds: 0,
    };
  },
  methods: {
    //验证码倒计时
    SecondsCount: function() {
      let _self = this;
      if (_self.seconds == 0) {
        clearInterval(timer);
      } else _self.seconds = _self.seconds - 1;
    },
 
    //获取验证码
    GetCode: function() {
      let _self = this;
      //判断是否可以执行获取验证码
      if (_self.seconds > 0) return;

      //获取验证码
      let param = {
        tel: _self.tel
      };
      _self.axios
        .post("/api/tourist/Member/GetCode", param)
        .then(res => {
          _self.$messagebox({
            title: "提示",
            message: "验证码已发送，注意查收",
          });
          _self.seconds = 60;
          timer = setInterval(_self.SecondsCount, 1000);
        })
        .catch(error => {});
    },
    //验证码登录
    Login: function() {
      let _self = this;
     
      let param = {
        tel: _self.tel,
        code: _self.code,
        timeStamp: new Date().getTime()
      };

      _self.axios
        .post("/api/tourist/Member/Login", param)
        .then(res => {
           _self.$common.SetUserInfo(res.data);
            _self.$common.SetCookie("TripTel", res.data.tel, 1);
            _self.$common.SetCookie("TripTimeStamp", res.data.timeStamp, 1);
            _self.$common.SetCookie("TripToken", res.data.token, 1);

            _self.$root.SetSession(
              res.data.token,
              res.data.userId,
              res.data.timeStamp
            );
            let url = sessionStorage.getItem("TripUrl");
            if (url == null) {
              _self.$router.push("/HomePage");
            } else {
              _self.$router.push(url);
            }
          
        })
        .catch(error => {});
    },
    //cookie缓存登录
    CacheLogin: function(tel, timeStamp, token) {
      let _self = this;
      let param = {
        tel: tel,
        timeStamp: timeStamp,
        token: token
      };
      _self.axios
        .post("/api/tourist/Member/CacheLogin", param)
        .then(res => {
          _self.$common.SetUserInfo(res.data);

          _self.$root.SetSession(
            res.data.token,
            res.data.userId,
            res.data.timeStamp
          );

          let url = sessionStorage.getItem("TripUrl");
          if (url == null) {
            _self.$router.push("/HomePage");
          } else {
            _self.$router.push(url);
          }
        })
        .catch(error => {});
    }
  },
  mounted() {
    // history.pushState(null, null, document.URL);
    // window.addEventListener("popstate", function() {
    //   history.pushState(null, null, document.URL);
    // });

    let _self = this;
    let tel = _self.$common.GetCookie("TripTel");
    let timeStamp = _self.$common.GetCookie("TripTimeStamp");
    let token = _self.$common.GetCookie("TripToken");

    if (tel != "" && timeStamp != "" && token != "") {

      _self.CacheLogin(tel, timeStamp, token);
    } else {

    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.Login {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .main {
    width: 90%;
    box-sizing: border-box;

    .header {
      width: 100%;
      text-align: center;
      box-sizing: border-box;
      flex-shrink: 0;
      img {
        width: 350px;
        height: 350px;
      }
    }

    .panel {
      margin-top: 10px;
      width: 100%;
      box-sizing: border-box;

      .input {
        width: 100%;
        border-bottom: 1px solid #ddd;
        padding: 20px 0;
        box-sizing: border-box;
        font-size: 30px;

        input {
          width: 100%;
          font-size: 30px;
          outline: none;
          border: 0;
        }
      }

      .code {
        margin-top: 30px;
        padding-top: 20px;
        width: 100%;
        // padding: 20px 0;
        box-sizing: border-box;
        margin-top: 30px;
        display: flex;
        flex-wrap: nowrap;
        position: relative;

        input {
          width: 40%;
          padding: 20px 0;
          border: 0;
          border-bottom: 1px solid #ddd;
          box-sizing: border-box;
          margin-right: 40px;
          outline: none;
          font-size: 30px;
        }
        span {
          bottom: 0;
          right: 0;
          position: absolute;
          background-color: #35b0fd;
          border-radius: 35px;
          flex-shrink: 0;
          padding: 20px 30px;
          box-sizing: border-box;
          letter-spacing: 2px;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 30px;
          width: 45%;
        }

        .wait {
          background: #ddd !important;
        }
      }
    }

    .btnLogin {
        flex-shrink: 0;
          width: 100%;
          margin: auto 0;
          background-color: #35b0fd;
          border-radius: 50px;
          color: white;
          margin-top: 50px;
          padding: 20px;
          box-sizing: border-box;
          font-size: 40px;
          letter-spacing: 3px;
          display: flex;
          align-items: center;
          justify-content: center;
    
    }


    .footer {
      width: 100%;
      margin-top: 50px;
      box-sizing: border-box;
      text-align: center;
      .tips {
        letter-spacing: 2px;
        color: #35b0fd;
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue